module.exports = __webpack_public_path__ + "img/artillery-wagon-base-10.fd792521.png";